import { render, staticRenderFns } from "./FileError.vue?vue&type=template&id=7b1934fc&scoped=true"
import script from "./FileError.vue?vue&type=script&lang=js"
export * from "./FileError.vue?vue&type=script&lang=js"
import style0 from "./FileError.vue?vue&type=style&index=0&id=7b1934fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1934fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b1934fc')) {
      api.createRecord('7b1934fc', component.options)
    } else {
      api.reload('7b1934fc', component.options)
    }
    module.hot.accept("./FileError.vue?vue&type=template&id=7b1934fc&scoped=true", function () {
      api.rerender('7b1934fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/massiveCertificationLoad/components/FileError.vue"
export default component.exports